export default {
  keyFields: ['noteId'],
};
